
import './App.css';
import { FitnessCategory } from "./https/http";
import About from './components/About';


import Home from './components/Home';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";

import Workout from './components/Workout';
import YogaPage from './components/YogaPage';
import UserProfile from './components/UserProfile';
import Arobics from './components/Arobics';
import Wellness from './components/Wellness';
import Food from './components/Food';
import { useEffect, useState } from 'react';


function App() {
  // const [videos, setVideos] = useState([]);

//   useEffect(() => {
//   const fetchVideos = async () => {
//     try {
//       const res = await FitnessCategory();
//       console.log(res.data?.data?.videos[0]?.videos[0].video_thumbnail ,"--------")
//       const categoryVideos = res.data?.data?.videos || [];
//       console.log("CATEGORY VIDEOS ARRAY:", categoryVideos);

//       categoryVideos.forEach(cat => {
//         console.log("Category:", cat.category, "Videos:", cat.videos);
//       });

//       const oneVideoPerCategory = categoryVideos
//         .map(cat => {
//           if (Array.isArray(cat.videos) && cat.videos.length > 0) {
//             const video = cat.videos[0].videos[0];
//             console.log(video,"------vvvvv-")
//             return {
//               id: video.id,
//               video_src: video.video_src || "#",
//               video_thumbnail: video.video_thumbnail || "/default-thumb.jpg",
//               categoryName: cat.category || "No Category",
           
//             };
//           }
//           return null;
//         })
//         .filter(Boolean);

//       console.log("homevideos", oneVideoPerCategory);

//       setVideos(oneVideoPerCategory);
//     } catch (error) {
//       console.error("API error:", error);
//       setVideos([]);
//     }
//   };

//   fetchVideos();
// }, []);
  return (
    <Router>
      <Routes>
        <Route path='/' element= {<Home />}/>
        <Route path="/about" element={<About/>} />
        <Route path="/Health Tips/:id" element={<Food/>}/>
        <Route path="/yoga/:id" element={<YogaPage/>}/>
        <Route path="/Aerobics/:id" element={<Arobics/>}/>
        <Route path="/Exercise/:id" element={<Workout/>}/>
        <Route path="/profile" element={<UserProfile/>}/>
        <Route path="/wellness/:id" element={<Wellness/>}/>

      </Routes>
    </Router>
  );
}

export default App;
